module.exports = __webpack_public_path__ + "media/images/current_magazine_issue_2-fc4a84ea6e0aaed24146725bb9dba9aa.png";